import React from "react"
import PropTypes from "prop-types"

import { breakpointEvaluator, textBreakpointComparator } from "quorumdesign/src/utils/helperFunctions"
import { Container, Title, Subtitle } from "app/static/frontend/profiles-new/containers/shared/DataItem/styles"

const SMALL_ELEMENT_CHARS = 16
const MEDIUM_ELEMENT_CHARS = 32
const LARGE_ELEMENT_CHARS = 64
const SUPER_LARGE_ELEMENT_CHARS = 128
const MAX_ELEMENT_CHARS = Number.MAX_SAFE_INTEGER

const SMALL_ELEMENT_INCREMENTS = 2
const MEDIUM_ELEMENT_INCREMENTS = 3
const LARGE_ELEMENT_INCREMENTS = 4
const SUPER_LARGE_ELEMENT_INCREMENTS = 6
const MAX_ELEMENT_INCREMENTS = 12

const ELEMENT_CONTENT_BREAKPOINTS = [
    { characters: SMALL_ELEMENT_CHARS, increments: SMALL_ELEMENT_INCREMENTS },
    { characters: MEDIUM_ELEMENT_CHARS, increments: MEDIUM_ELEMENT_INCREMENTS },
    { characters: LARGE_ELEMENT_CHARS, increments: LARGE_ELEMENT_INCREMENTS },
    { characters: SUPER_LARGE_ELEMENT_CHARS, increments: SUPER_LARGE_ELEMENT_INCREMENTS },
    { characters: MAX_ELEMENT_CHARS, increments: MAX_ELEMENT_INCREMENTS },
]

const ITEMS_PER_LINE = 12

export const DataItem = (props) => {
    const gridIncrement = Math.floor(props.gridWidth / ITEMS_PER_LINE)
    const increments = breakpointEvaluator({
        breakpointsArray: ELEMENT_CONTENT_BREAKPOINTS,
        comparator: textBreakpointComparator,
        item: props.title.length > props.subtitle.length ? props.title : props.subtitle,
    }).increments
    const columnSpan = Math.floor(increments * gridIncrement)

    return (
        <Container columnSpan={props.columnSpan ?? columnSpan}>
            <Title>{props.title}</Title>
            <Subtitle>{props.subtitle}</Subtitle>
        </Container>
    )
}

DataItem.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    gridWidth: PropTypes.number,
}
